import Grid from "@material-ui/core/Grid"

import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs"
import { Button } from "@progress/kendo-react-buttons"

function ConfirmDialog(props) {
  const { title, content, close, confirm, closeOnConfirm } = props

  return (
    <Dialog title={title} onClose={close}>
      <Grid
        container
        item
        direction="column"
        style={{ maxWidth: "640px", maxHeight: "640px" }}
      >
        <Grid item>
          <p style={{ paddingBottom: "1rem", paddingTop: "1rem" }}>{content}</p>
        </Grid>
      </Grid>

      <DialogActionsBar>
        <Button onClick={close} style={{ color: "white", backgroundColor:"#7ABCCE" }}
          themeColor={"primary"}>
          Cancel
        </Button>
        <Button
          style={{ color: "white", backgroundColor:"#7ABCCE" }}
          themeColor={"primary"}
          onClick={async () => {
            if (closeOnConfirm) close()
            await confirm()
            if (!closeOnConfirm) close()
          }}
        >
          Confirm
        </Button>
      </DialogActionsBar>
    </Dialog>
  )
}

export default ConfirmDialog
